import axios from "~/plugins/axios";

const baseEndpoint = "/web_api/v1/compare/";

export default {
  /**
  * @param {string} compareType
  * @param {Object} routeParams
  */
  getCalculationValues(compareType, routeParams) {
    return axios.get(`${baseEndpoint + compareType}/calculation_values`, { params: routeParams })
      .then((response) => response.data);
  },
  compare(compareType, overrides, routeParams) {
    return axios.post(baseEndpoint + compareType, overrides, { params: routeParams })
      .then((response) => response.data);
  },
  save(compareType, overrides, routeParams) {
    return axios.post(baseEndpoint + compareType, overrides, {
      params: { save: 1, ...routeParams },
    }).then((response) => response.data);
  },
  compareCarPremiums(routeParams) {
    return axios.post(`${baseEndpoint}car/compare_premiums`, null, { params: routeParams })
      .then((response) => response.data);
  },
  getCompareSummary(customerId) {
    return axios.get(`${baseEndpoint}customer/${customerId}/summary`)
      .then((response) => response.data);
  },
  getCompareSummaryPDF(customerId) {
    return axios.get(`${baseEndpoint}customer/${customerId}/summary/pdf`)
      .then((response) => response.data);
  },
};
